import { jsxs as m, jsx as o, Fragment as M } from "react/jsx-runtime";
import l from "react";
import { RangoBrand as R } from "../es/Brand.js";
import { m as p } from "./breakpoints.907eaecd.js";
import d, { css as r, styled as h } from "styled-components";
import { u as D } from "./useResponsive.abbd7f84.js";
import { R as H } from "./Description.be3b00d1.js";
import { R as k, a as S, H as B } from "./Heading.2a0f9b41.js";
import { RangoButtonIconHighlight as O } from "../es/ButtonIconHighlight.js";
const $ = d.div.withConfig({
  displayName: "Container",
  componentId: "sc-1osk6sh-0"
})(["width:100%;height:auto;min-height:var(--spacing-5x);display:flex;flex-wrap:nowrap;gap:var(--spacing-4x);"]), E = d.div.withConfig({
  displayName: "DescriptionContainer",
  componentId: "sc-1osk6sh-1"
})(["display:flex;flex-flow:column nowrap;justify-content:center;"]), I = d(H).withConfig({
  displayName: "DescriptionContent",
  componentId: "sc-1osk6sh-2"
})(["color:var(--inverse-description-color);"]), K = l.forwardRef(({
  firstText: n,
  secondText: t,
  brandProps: e,
  ...s
}, c) => /* @__PURE__ */ m($, { ...s, ref: c, children: [
  /* @__PURE__ */ o(R, { ...e }),
  /* @__PURE__ */ m(E, { children: [
    /* @__PURE__ */ o(I, { children: n }),
    /* @__PURE__ */ o(I, { children: t })
  ] })
] }));
K.displayName = "RangoFooterBrandDescription";
const z = d.div.withConfig({
  displayName: "Container",
  componentId: "sc-yd61i-0"
})(["display:flex;flex-direction:column;width:100%;"]), U = d(k).withConfig({
  displayName: "ColumnTitle",
  componentId: "sc-yd61i-1"
})(["color:var(--inverse-heading-color);"]), Y = d.div.withConfig({
  displayName: "ContainerContent",
  componentId: "sc-yd61i-2"
})(["display:flex;flex-direction:column;align-items:flex-start;padding-top:var(--spacing-2x);width:100%;& > button{color:var(--inverse-label-color);}"]), G = l.forwardRef(({
  title: n,
  children: t,
  onChildClick: e,
  ...s
}, c) => {
  const w = (a, i) => {
    e && e(a), i && i(a);
  }, g = () => l.Children.map(t, (a) => {
    const i = a.props.onClick;
    return [l.cloneElement(a, {
      ...a.props,
      onClick: (x) => w(x, i)
    })];
  });
  return /* @__PURE__ */ m(z, { ref: c, ...s, children: [
    /* @__PURE__ */ o(U, { tag: S.H3, size: B.XS, children: n }),
    /* @__PURE__ */ o(Y, { children: g() })
  ] });
});
G.displayName = "RangoFooterColumns";
const X = d(k).withConfig({
  displayName: "Title",
  componentId: "sc-1xd2s7m-0"
})(["color:var(--inverse-heading-color);"]), _ = d.div.withConfig({
  displayName: "Container",
  componentId: "sc-1xd2s7m-1"
})(["display:flex;flex-direction:column;height:auto;min-height:85px;width:100%;max-width:304px;"]), C = d(O).withConfig({
  displayName: "SocialMediaButton",
  componentId: "sc-1xd2s7m-2"
})(["background:transparent;border-color:var(--inverse-border-color);& > div{color:var(--inverse-icon-color);}"]), q = d.div.withConfig({
  displayName: "SocialMediasContainer",
  componentId: "sc-1xd2s7m-3"
})(["display:flex;padding-top:var(--spacing-2x);gap:var(--spacing-2x);width:100%;flex-wrap:nowrap;", ""], p.sm(r(["flex-wrap:wrap;"]))), f = {
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram",
  LINKEDIN: "linkedin",
  YOUTUBE: "youtube",
  TIKTOK: "tiktok"
};
Object.values(f);
const J = l.forwardRef(({
  facebookProps: n,
  instagramProps: t,
  linkedInProps: e,
  youtubeProps: s,
  tiktokProps: c,
  title: w = "Acompanhe nossas redes sociais:",
  onSocialMediaClick: g
}, a) => {
  const i = (x) => {
    g && g(x);
  };
  return /* @__PURE__ */ m(_, { ref: a, children: [
    /* @__PURE__ */ o(X, { size: B["2XS"], tag: S.H3, children: w }),
    /* @__PURE__ */ m(q, { children: [
      n && /* @__PURE__ */ o(C, { ariaLabel: "Botão da rede social Facebook", icon: "FacebookLine", forwardedAs: "a", onClick: () => i(f.FACEBOOK), ...n }),
      t && /* @__PURE__ */ o(C, { ariaLabel: "Botão da rede social Instagram", forwardedAs: "a", icon: "InstagramLine", onClick: () => i(f.INSTAGRAM), ...t }),
      e && /* @__PURE__ */ o(C, { ariaLabel: "Botão da rede social LinkedIn", icon: "LinkedinLine", forwardedAs: "a", onClick: () => i(f.LINKEDIN), ...e }),
      s && /* @__PURE__ */ o(C, { ariaLabel: "Botão da rede social Youtube", icon: "YoutubeLine", forwardedAs: "a", onClick: () => i(f.YOUTUBE), ...s }),
      c && /* @__PURE__ */ o(C, { ariaLabel: "Botão da rede social Tiktok", icon: "TiktokLine", forwardedAs: "a", onClick: () => i(f.TIKTOK), ...c })
    ] })
  ] });
});
J.displayName = "RangoFooterSocialMedia";
const u = h(R).withConfig({
  displayName: "LogotypeBrand",
  componentId: "sc-18j6tbe-0"
})({}), L = h.div.withConfig({
  displayName: "SlotBaseContainer",
  componentId: "sc-18j6tbe-1"
})(["height:100%;flex-direction:row;align-items:center;order:2;& > ", "{padding-bottom:0px;}", ""], u, p.md(r`
    flex-direction: column;
    align-items: flex-start !important;
    order: 1;

    & > ${u} {
      padding-bottom: var(--spacing-10x);
      height: 40px;
    }
  `)), N = h.div.withConfig({
  displayName: "Slot",
  componentId: "sc-18j6tbe-2"
})(["display:", ";", " ", ""], ({
  $showSlot1: n,
  $showSlot2: t
}) => n || t ? "block" : "none", ({
  $showSlot1: n
}) => n && r`
      ${p.md(r`
        padding: var(--spacing-4x) var(--spacing-3x) 0 var(--spacing-3x);
        width: 100% & > [slot= 'slot1'] {
          width: 100% !important;
        }
      `)}
    `, ({
  $showSlot2: n
}) => n && r`
      ${p.md(r`
        padding: var(--spacing-4x) var(--spacing-3x);
        width: 100%;

        & > [slot='slot2'] {
          width: 100% !important;
        }
      `)}
    `), y = h.div.withConfig({
  displayName: "SlotNavigation",
  componentId: "sc-18j6tbe-3"
})(["height:100%;order:1;div[slot='navigation']{display:flex;flex-flow:row nowrap;justify-content:space-between;width:100%;gap:var(--spacing-6x);}", ""], p.md(r`
    order: 2;
    width: 100%;
    & > [slot='navigation'] {
      width: 100% !important;
    }
  `)), F = h.div.withConfig({
  displayName: "SlotBottom",
  componentId: "sc-18j6tbe-4"
})(["height:100%;order:2;", ""], p.md(r`
    order: 3;
    width: 100%;
    & > [slot='bottom'] {
      width: 100% !important;
    }
  `)), Q = h.footer.withConfig({
  displayName: "Container",
  componentId: "sc-18j6tbe-5"
})(["width:100%;display:flex;flex-direction:column;background-color:var(--elements-bg-color-05);color:var(--inverse-label-color);& > ", ",& > ", ",& > ", "{display:flex;align-items:center;justify-content:space-between;padding:var(--spacing-5x);box-sizing:border-box;", "}& > ", "{", "}"], L, y, F, p.md(r`
      padding: var(--spacing-4x) var(--spacing-3x);
    `), y, p.md(r`
      padding: var(--spacing-4x) 0;
    `)), V = l.forwardRef(({
  showBase: n = !0,
  showNavigation: t = !0,
  showBottom: e = !0,
  showBrand: s = !0,
  showSlot1: c = !0,
  showSlot2: w = !0,
  children: g,
  brandProps: a,
  onResponsive: i,
  ...x
}, T) => {
  const b = D(1023);
  l.useEffect(() => i && i(b), [b]);
  const v = (A) => l.Children.toArray(g).filter((j) => j.props.slot === A);
  return /* @__PURE__ */ o(M, { children: (t || n || e) && /* @__PURE__ */ m(Q, { ref: T, "data-testid": "rango-footer-container", "data-rango-component": "rango-footer-container", "data-is-rango": !0, ...x, children: [
    t && /* @__PURE__ */ o(y, { "data-testid": "rango-footer-container-navigation", children: v("navigation") }),
    n && /* @__PURE__ */ m(L, { "data-testid": "rango-footer-container-base", children: [
      s && /* @__PURE__ */ o(u, { ...a }),
      /* @__PURE__ */ o(N, { $showSlot1: c, children: v("slot1") }),
      /* @__PURE__ */ o(N, { $showSlot2: w, children: v("slot2") })
    ] }),
    e && /* @__PURE__ */ o(F, { "data-testid": "rango-footer-container-bottom", children: v("bottom") })
  ] }) });
});
V.displayName = "RangoFooterContainer";
export {
  K as R,
  G as a,
  J as b,
  f as c,
  V as d
};
